module.exports = __webpack_public_path__ + "static/media/azerturk.3f3bd0ee.svg";